import { trackEvent } from "utils/analytics";

// Unified Signup Clicked
// Moreden Signup Clicked
// Unified Signup Agree Clicked
// Signup Next Step Clicked
// Signup Submitted
// License Registration Clicked
// Home Return Clicked

export const trackQuickMenuClicked = (property: object) => {
  trackEvent("Quick Menu Clicked", property);
};

export const trackHoverSubTabClicked = (property: object) => {
  trackEvent("Hover Sub Tab Click", property);
};

export const trackShurinkConsultationClicked = (property: object) => {
  trackEvent("Shurink Consultation Clicked", property);
};

export const trackHermannryffConsultationClicked = (property: object) => {
  trackEvent("Hermannryff Consultation Clicked", property);
};

export const trackRayConsultationClicked = (property: object) => {
  trackEvent("Ray Consultation Clicked", property);
};

export const trackRayLearnMoreClicked = (property: object) => {
  trackEvent("Ray Learn More Clicked", property);
};

export const trackChicruitingStartClicked = (property: object) => {
  trackEvent("Chicruiting Start Clicked", property);
};

export const trackHomePeopleProposalClicked = (property: object) => {
  trackEvent("Home People Proposal Clicked", property);
};

export const trackHomeMorePeopleViewed = (property: object) => {
  trackEvent("Home More People Viewed", property);
};

export const trackHeaderMenuClicked = (property: object) => {
  trackEvent("Header Menu Clicked", property);
};

export const trackAdsClicked = (property: object) => {
  trackEvent("Ads Clicked", property);
};

export const trackAdsViewed = (property: object) => {
  trackEvent("Ads Viewed", property);
};

export const trackUnifiedSignupClicked = (property: object) => {
  trackEvent("Unified Signup Clicked", property);
};

export const trackMoredenSignupClicked = (property: object) => {
  trackEvent("Moreden Signup Clicked", property);
};

export const trackUnifiedSignupAgreeClicked = (property: object) => {
  trackEvent("Unified Signup Agree Clicked", property);
};

export const trackSignupNextStepClicked = (property: object) => {
  trackEvent("Signup Next Step Clicked", property);
};

export const trackSignupSubmitted = (property: object) => {
  trackEvent("Signup Submitted", property);
};

export const trackLicenseRegistrationClicked = (property: object) => {
  trackEvent("License Registration Clicked", property);
};

export const trackHomeReturnClicked = (property: object) => {
  trackEvent("Home Return Clicked", property);
};

export const trackJobSelectionButtonClicked = (property: object) => {
  trackEvent("Job Selection Button Clicked", property);
};

export const trackManagementReviewClicked = (property: object) => {
  trackEvent("Management Review Clicked", property);
};

export const trackManagementReviewMoreClicked = (property: object) => {
  trackEvent("Management Review More Clicked", property);
};

export const trackBannerClicked = (property: object) => {
  trackEvent("Banner Clicked", property);
};

export const trackManagementAdsTabClicked = (property: object) => {
  trackEvent("Management Ads Tab Clicked", property);
};

export const trackManagementAdsClicked = (property: object) => {
  trackEvent("Management Ads Clicked", property);
};

export const trackManagementEstateClicked = (property: object) => {
  trackEvent("Management Estate Clicked", property);
};

export const trackManagementMarketClicked = (property: object) => {
  trackEvent("Management Market Clicked", property);
};

export const trackManagementPartnerClicked = (property: object) => {
  trackEvent("Management Partner Clicked", property);
};

export const trackRecommendedChannelClicked = (property: object) => {
  trackEvent("Recommended Channel Clicked", property);
};

export const trackWidgetCouponButtonClicked = (property: object) => {
  trackEvent("WidgetCouponButton Clicked", property);
};

export const trackWidgetPointButtonClicked = (property: object) => {
  trackEvent("WidgetPointButton Clicked", property);
};

export const trackWidgetCashButtonClicked = (property: object) => {
  trackEvent("WidgetCashButton Clicked", property);
};

export const trackSeminarCategoryFilterClicked = (property: object) => {
  trackEvent("Seminar Category Filter Clicked", property);
};
